import React from "react";
import { Heading } from "@aws-amplify/ui-react";
import { useMedicalConditionsQuery } from "./api/useMedicalConditionQuery";
import MedicalConditionCard from "./MedicalConditionCard";
import { useUserQuery } from "../common/useUserQuery";

export default function MedicalConditionsPage() {
  const { data: userQueryData } = useUserQuery();
  const {
    error,
    data: medicalConditionResults,
    isFetching,
  } = useMedicalConditionsQuery(userQueryData?.patientUserId);

  if (isFetching) return "Loading...";

  if (error) return "An error happened, try refreshing the browser.";

  return (
    <>
      {medicalConditionResults?.filter(
        (medicalCondition) =>
          medicalCondition.medicalConditionStage === "DIAGNOSED"
      ).length > 0 && <Heading level="6" children="Diagnosed"></Heading>}

      {medicalConditionResults.length > 0 &&
        medicalConditionResults?.map((medicalCondition) => {
          if (medicalCondition.medicalConditionStage !== "DIAGNOSED") {
            return false;
          }
          return (
            <MedicalConditionCard
              data={medicalCondition}
              key={`mc_di_${medicalCondition.id}`}
            />
          );
        })}
      {medicalConditionResults?.filter(
        (medicalCondition) =>
          medicalCondition.medicalConditionStage === "PRESUMED"
      ).length > 0 && <Heading level="6" children="Presumed"></Heading>}

      {medicalConditionResults.length > 0 &&
        medicalConditionResults?.map((medicalCondition) => {
          if (medicalCondition.medicalConditionStage !== "PRESUMED") {
            return false;
          }
          return (
            <MedicalConditionCard
              data={medicalCondition}
              key={`mc_pr_${medicalCondition.id}`}
            />
          );
        })}
      {medicalConditionResults?.filter(
        (medicalCondition) =>
          medicalCondition.medicalConditionStage === "POTENTIAL"
      ).length > 0 && <Heading level="6" children="Potential"></Heading>}

      {medicalConditionResults.length > 0 &&
        medicalConditionResults?.map((medicalCondition) => {
          if (medicalCondition.medicalConditionStage !== "POTENTIAL") {
            return false;
          }
          return (
            <MedicalConditionCard
              data={medicalCondition}
              key={`mc_po_${medicalCondition.id}`}
            />
          );
        })}

      {medicalConditionResults?.filter(
        (medicalCondition) =>
          medicalCondition.medicalConditionStage === "RULED OUT"
      ).length > 0 && <Heading level="6" children="Ruled out"></Heading>}

      {medicalConditionResults?.map((medicalCondition) => {
        if (medicalCondition.medicalConditionStage !== "RULED OUT") {
          return false;
        }
        return (
          <MedicalConditionCard
            data={medicalCondition}
            key={`mc_po_${medicalCondition.id}`}
          />
        );
      })}
    </>
  );
}
